enum WorkspaceProjectClosedQuestions {
  'Yes' = 'Yes',
  'No' = 'No',
}

export default WorkspaceProjectClosedQuestions
